module.exports = __webpack_public_path__ + "static/media/13.10f529e4.jpg";